import { LocalAddress } from './local-address.model';
import { LocalLocationType } from './local-location-type';

export class ManualLocalLocationCreationRequest {

  public name: string;
  public glid: string;
  public type: LocalLocationType;
  public address = new LocalAddress();

  toDto(): any {
    return {
      name: this.name,
      glid: this.glid,
      type: this.type,
      address: this.address.toDto(),
    };
  }
}
